import React from 'react'
import StateRS from './StateRS'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from '../../../../css/RxartSecure/DevicesRS.module.css'

export default function DeviceDataHeader ({ data }) {
  const { t } = useTranslation('dashboardDevice')
  const typesDevice = [
    { key: 'desktop', value: t('modalRxartSecure.label15') },
    { key: 'notebook', value: t('modalRxartSecure.label16') },
    { key: 'tablet', value: t('modalRxartSecure.label17') },
    { key: 'smartphone', value: t('modalRxartSecure.label18') }
  ]

  const deviceTypeLabel =
    typesDevice.find(
      type => type.key === data?.device?.deviceType?.toLowerCase()
    )?.value || data?.device?.deviceType

  return (
    <div className={styles.deviceDataHeader}>
        {deviceTypeLabel && <span>{deviceTypeLabel}</span>}
        {data?.device?.license && <span>{data?.device?.license}</span>}
        {data?.device?.statusId && <StateRS state={data?.device?.statusId} size={'0.9rem'} />}
    </div>
  )
}

DeviceDataHeader.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
  device: PropTypes.object,
  bios: PropTypes.string,
  setBios: PropTypes.func,
  actions: PropTypes.object,
  setComponentsModalRS: PropTypes.func,
  setActiveIndex: PropTypes.func,
  modalsShow: PropTypes.object,
  setModalsShow: PropTypes.func
}
